import type { ResourceListOptions } from '#dn-types/api.ts';
import type { EndpointOIDCUser } from '#dn-types/endpoint-oidc-user.ts';
import { getList } from './fetch.ts';

export const DEFAULT_ENDPOINT_OIDC_USERS_PAGE_SIZE = 100;

// GET /endpoint-oidc-users
export type GetEndpointOIDCUsersResult = EndpointOIDCUser[];
export function getEndpointOIDCUsers({
  cursor = '',
  pageSize = DEFAULT_ENDPOINT_OIDC_USERS_PAGE_SIZE,
  init,
}: ResourceListOptions = {}) {
  return getList<GetEndpointOIDCUsersResult>(
    `/v1/endpoint-oidc-users?cursor=${encodeURIComponent(cursor)}&pageSize=${pageSize}`,
    init
  ).then((res) => {
    // We're not actually paginating, otherwise we would need to do the "paginating backwards two-step shuffle"
    return res;
  });
}
